import { useMemo } from 'react'
import { useAuth } from '@/hooks/useAuth'
import type { TableViewScope } from '@/types/shared/table-view.types'

export function useTableViewScope(): TableViewScope | null {
  const { contextData } = useAuth()

  return useMemo(() => {
    if (!contextData?.contextType) return null
    const scope = contextData.contextType
    if (scope === 'platform') {
      return { scope: 'platform', organizationId: null, branchId: null }
    }
    if (scope === 'organization') {
      if (!contextData.organizationId) return null
      return {
        scope: 'organization',
        organizationId: contextData.organizationId,
        branchId: null,
      }
    }
    if (!contextData.organizationId || !contextData.branchId) return null
    return {
      scope: 'branch',
      organizationId: contextData.organizationId,
      branchId: contextData.branchId,
    }
  }, [contextData?.contextType, contextData?.organizationId, contextData?.branchId])
}

export function tableViewScopeCacheKey(scope: TableViewScope | null): string | null {
  if (!scope) return null
  if (scope.scope === 'platform') return 'platform||'
  if (scope.scope === 'organization') return `organization|${scope.organizationId ?? ''}|`
  return `branch|${scope.organizationId ?? ''}|${scope.branchId ?? ''}`
}
